<template>
  <ResultForm :data="data" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import ResultForm from "./ResultForm.vue"

import moment from "moment"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      resultData: null,
      lotto: {
        lotto_date: moment().format("YYYY-MM-DD"),
        round: '',
        round_id: '',
        close_date: '',
        start_spin: '',
        show_result: '',
        result: {
          number: null,
          threeTop: null,
          twoTop: null,
          twoBot: null
        },
        effect: null,
        status: 'Public'
      },
    }
  },
  computed: {
    data() {
      return this.lotto
    },
    digit5() {
      return this.lotto.result.number
    }
  },
  watch: {
    digit5(val) {
      if (val) {
        let res = val.split("")
        if (res.length === 5) {
          this.lotto.result.threeTop = `${res[2]}${res[3]}${res[4]}`
          this.lotto.result.twoTop = `${res[3]}${res[4]}`
          this.lotto.result.twoBot = `${res[0]}${res[1]}`
        } else {
          this.lotto.result.threeTop = ''
          this.lotto.result.twoTop = ''
          this.lotto.result.twoBot = ''
        }
      } else {
        this.lotto.result.threeTop = ''
        this.lotto.result.twoTop = ''
        this.lotto.result.twoBot = ''
      }
    }
  },
  methods: {
    loadResult() {
      LottoService.getResult(this.$route.params.resultDate, this.$route.params.resultId).then((response) => {
        if (response.status === 'success') {
          this.resultData = response.data
          this.lotto.lotto_date = this.resultData.lotto_date
          this.lotto.round = this.resultData.round
          this.lotto.round_id = this.resultData.round_id
          this.lotto.close_date = this.resultData.close_date
          this.lotto.start_spin = this.resultData.start_spin
          this.lotto.show_result = this.resultData.show_result
          this.lotto.result = this.resultData.result
          this.lotto.effect = this.resultData.effect
          this.lotto.status = this.resultData.status
        } else {
          this.$router.push({ name: 'admin-results' })
        }
      })
    },
    save(data) {
      LottoService.updateResult(this.$route.params.resultDate, this.$route.params.resultId, data).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-results', params: { resultDate: this.lotto.lotto_date } })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  },
  created() {
    this.loadResult()
  }
}

</script>
